export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '题目标题',
    dataIndex: 'question',
  },
  {
    title: '题目类型',
    dataIndex: 'type',
    customRender: (text, record, index)=>{
      if(record.type===0){
        return '问答题';
      }else if(record.type===1){
        return '单选题';
      }else{
        return '多选题';
      }
    },
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
